// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claim from './attachment-claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import failureModes from './failure-modes';
import formValidation from './form-validation';
import isActionButtonDisabled from './is-action-button-disabled';
import isCopied from './is-copied';
import isEditable from './is-editable';
import isStickyHeaderVisible from './is-sticky-header-visible';
import isValidClaim from './is-valid-claim';
import temporaryObjectKey from './temporary-object-key';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    failureModes,
    formValidation,
    isActionButtonDisabled,
    isCopied,
    isEditable,
    isStickyHeaderVisible,
    isValidClaim,
    temporaryObjectKey
});




// WEBPACK FOOTER //
// ./src/claim/attachment/reducers/index.js